"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var DownloadAppBanner = /** @class */ (function (_super) {
    __extends(DownloadAppBanner, _super);
    function DownloadAppBanner() {
        var _this = _super.call(this) || this;
        _this.iosAppLink = '';
        _this.androidAppLink = '';
        return _this;
    }
    DownloadAppBanner.prototype.mounted = function () {
        switch (this.$route.params.partnershipSlug) {
            case 'saint-olav-ways':
                this.iosAppLink = 'https://apps.apple.com/es/app/rurallure-saint-olav-way/id1641736536';
                this.androidAppLink = 'https://play.google.com/store/apps/details?id=com.gvam.ruralluresaintolav';
                break;
            case 'ways-to-santiago-de-compostela':
                this.iosAppLink = 'https://apps.apple.com/es/app/rurallure-santiago/id1634791857';
                this.androidAppLink = 'https://play.google.com/store/apps/details?id=com.gvam.rurallurecaminodesantiago';
                break;
            case 'ways-to-rome':
                this.iosAppLink = 'https://apps.apple.com/es/app/rome-rurallure/id1640532533';
                this.androidAppLink = 'https://play.google.com/store/apps/details?id=com.gvam.rurallurerome';
                break;
            case 'ways-to-csiksomlyo':
                this.iosAppLink = 'https://apps.apple.com/es/app/rurallure-cs%C3%ADksomly%C3%B3-way/id1641737000';
                this.androidAppLink = 'https://play.google.com/store/apps/details?id=com.gvam.rurallurecsiksomlyo';
                break;
        }
    };
    DownloadAppBanner = __decorate([
        vue_property_decorator_1.Component({
            name: 'DownloadAppBanner',
            components: {}
        })
    ], DownloadAppBanner);
    return DownloadAppBanner;
}(vue_1.default));
exports.default = DownloadAppBanner;
